import React, {useState} from 'react';
import {TaskData} from '../../../../types/TaskData';
import './ColorReservation.css';
import ColorReservationTable from "../colorReservationTable/ColorReservationTable";
import ColorReservationCreation from "../colorReservationCreation/./ColorReservationCreation";
import {ViewType} from "../../../../types/ViewType";

const ColorReservation: React.FC = () => {
    const [selectedRow, setSelectedRow] = useState<TaskData | null>(null);
    const [refreshKey, setRefreshKey] = useState(0);

    const handleRowSelect = (row: TaskData | null) => {
        setSelectedRow(row);
    };

    const onRefreshTable = () => {
        setSelectedRow(null);
        setRefreshKey(prevKey => prevKey + 1);
    };

    return (
        <div className="measure-order-container">
            <div className="table-container-reservation">
                <ColorReservationTable onSelectRow={handleRowSelect}
                                       refreshKey={refreshKey}/>
            </div>
            <div className="detail-container-reservation">
                {selectedRow && (
                    <ColorReservationCreation
                        key={selectedRow.id}
                        data={selectedRow!}
                        onRefreshTable={onRefreshTable}
                        viewType={ViewType.NEW}
                        type="color"></ColorReservationCreation>

                )}
            </div>
        </div>
    );
};

export default ColorReservation;
